<app-web-navbar></app-web-navbar>


<div class="container py-4">

  <!-- ================= EMPTY CART ================= -->
  <div *ngIf="items.length === 0" class="text-center py-5">

    <img src="../../../../assets/img/new/empty-card.png" alt="Empty Cart" class="img-fluid" style="max-width: 280px;">

    <br><br>

    <button class="btn btn-primary px-4 mt-3" (click)="goToHome()">
      Shop More
    </button>

  </div>

  <!-- ================= CART ================= -->
  <div *ngIf="items.length > 0" class="row g-4">

    <!-- ================= LEFT : ITEMS ================= -->
    <div class="col-12 col-lg-7">
      <h4 class="fw-bold mb-3">🛒 Shopping Cart</h4>

      <div *ngFor="let item of items; let i = index" class="card border-0 shadow-sm rounded-4 mb-3 p-3 cart-item">
        <div class="row align-items-center">
          <div class="col-4 col-md-2 text-center">
            <img [src]="getImageByVariant(item.imageId)" class="img-fluid object-fit-contain" style="max-height:80px"
              (error)="onImageError($event)">
          </div>

          <div class="col-8 col-md-4">
            <h6 class="mb-1">{{ item.name }}</h6>
            <small>{{ item.barcodeNumber }}</small><br>
            <small>₹ {{ formatIndianCurrency(item.price) }}</small>

          </div>

          <!-- QTY -->
          <div class="col-6 col-md-3 mt-3 mt-md-0">
            <div class="qty-box d-flex justify-content-center">
              <button class="btn btn-light" (click)="updateQuantity(item,-1)" [disabled]="item.qty===1">−</button>

              <span class="px-3 fw-bold mt-2">{{ item.qty }}</span>

              <button class="btn btn-light" (click)="updateQuantity(item,1)">+</button>
            </div>
          </div>

          <!-- REMOVE -->
          <div class="col-6 col-md-3 text-end mt-3 mt-md-0">
            <button class="btn btn-outline-danger btn-sm" (click)="removeItem(item.cartItemId,i)">
              Remove
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- ================= RIGHT PANEL ================= -->
    <div class="col-12 col-lg-5">

      <!-- ================= BUYER TYPE ================= -->
      <div class="sticky-lg-top" style="top:20px">
        <div class="card border-0 shadow-sm rounded-4 mb-3">
          <div class="card-header bg-white fw-bold">Buyer Type</div>

          <div class="card-body">

            <div class="d-flex gap-4 mb-3">
              <div class="form-check">
                <input type="radio" class="form-check-input" value="USER" name="buyerType" [(ngModel)]="buyerType"
                  (change)="onBuyerTypeChange()">
                <label>User</label>
              </div>

              <div class="form-check">
                <input type="radio" class="form-check-input" value="RESELLER" name="buyerType" [(ngModel)]="buyerType"
                  (change)="onBuyerTypeChange()">
                <label>Reseller</label>
              </div>
            </div>

            <!-- RESELLER -->
            <div class="row g-3" *ngIf="buyerType==='RESELLER'">
              <!-- Reseller Name -->
              <div class="col-12 col-md-6">
                <input class="form-control" placeholder="Reseller Name" [(ngModel)]="resellerName" name="resellerName">

                <small class="text-danger"
                  *ngIf="resellerSubmitted && buyerType === 'RESELLER' && !resellerName?.trim()">
                  Reseller name is required
                </small>
              </div>


              <!-- Reseller Phone -->
              <div class="col-12 col-md-6">
                <input class="form-control" maxlength="10" placeholder="Phone" [(ngModel)]="resellerPhone"
                  name="resellerPhone" (input)="handleIndianPhone($event,'reseller')">

                <small class="text-danger" *ngIf="resellerPhoneTouched && !resellerPhone">
                  Phone number is required
                </small>

                <small class="text-danger"
                  *ngIf="resellerPhoneTouched && resellerPhone && !phonePattern.test(resellerPhone)">
                  Enter valid phone number (must start with 6,7,8,9)
                </small>
              </div>

            </div>

          </div>
        </div>

        <!-- ================= ADDRESS ================= -->
        <div class="card border-0 shadow-sm rounded-4 mb-3">
          <div class="card-header bg-white fw-bold">Delivery Address</div>

          <div class="card-body">

            <div *ngFor="let addr of userAddresses;let i=index" class="address-box p-3 rounded-3 mb-3">

              <div class="d-flex">
                <input type="radio" class="me-2 mt-1" [value]="addr.addressId" [(ngModel)]="selectedUserAddressId"
                  (change)="selectUserAddress(addr)">

                <div>
                  <strong>{{addr.name}}</strong>
                  <div class="small text-muted">
                    {{addr.doorNo}}, {{addr.streetName}}, {{addr.city}} - {{addr.pinCode}}
                  </div>
                  <div class="col-md-auto mt-2 mt-md-0 text-md-end">
                    <button class="btn btn-sm btn-outline-primary" (click)="editAddress(addr,i)"> Edit </button>
                  </div>
                </div>
              </div>
            </div>

            <button class="btn btn-outline-primary w-100" (click)="openAddressForm()">
              + Add / Change Address
            </button>

          </div>
        </div>

        <!-- ================= ADDRESS FORM ================= -->
        <div *ngIf="showAddressForm" class="card">
          <div class="card-body">
            <form [formGroup]="addressForm" class="row g-3">
              <!-- NAME -->
              <div class="col-md-6">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="name" placeholder="Name">
                  <label>Name <span class="text-danger">*</span></label>
                </div> <small class="text-danger" *ngIf="addressSubmitted && f.name.invalid">
                  Name is required </small>
              </div>

              <!-- PHONE -->
              <div class="col-md-6">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="phoneNumber" maxlength="10"
                    (input)="handleIndianPhone($event,'address')">
                  <label>Phone Number <span class="text-danger">*</span></label>
                </div>

                <small class="text-danger" *ngIf="f.phoneNumber.touched && f.phoneNumber.errors?.required">
                  Phone number is required
                </small>

                <small class="text-danger" *ngIf="f.phoneNumber.touched && f.phoneNumber.errors?.pattern">
                  Enter valid Indian mobile number (starts with 6,7,8,9)
                </small>
              </div>

              <!-- GST NO -->
              <div class="col-md-12">
                <div class="form-floating">
                  <input class="form-control" placeholder="GST (Optional)" formControlName="gstNumber">
                  <label>GST Number</label>
                </div>
              </div>

              <!-- DOOR NO -->
              <div class="col-md-4">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="doorNo" placeholder="Door No">
                  <label>Door No <span class="text-danger">*</span></label>
                </div>
                <small class="text-danger" *ngIf="addressSubmitted && f.doorNo.invalid"> Door No required </small>
              </div>

              <!-- STREET -->
              <div class="col-md-8">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="streetName" placeholder="Street">
                  <label>Street Name <span class="text-danger">*</span></label>
                </div>
                <small class="text-danger" *ngIf="addressSubmitted && f.streetName.invalid"> Street name required
                </small>
              </div>

              <!-- OPTIONAL -->
              <div class="col-md-6">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="area" placeholder="Area">
                  <label>Area (Optional)</label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="village" placeholder="Village">
                  <label>Village (Optional)</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="city" placeholder="City">
                  <label>City <span class="text-danger">*</span></label>
                  <small class="text-danger" *ngIf="addressSubmitted && f.city.invalid"> City name required
                  </small>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="landmark" placeholder="Landmark">
                  <label>Landmark (Optional)</label>
                </div>
              </div>

              <!-- STATE -->
              <div class="col-md-6">
                <div class="form-floating">
                  <select class="form-select" formControlName="state" (change)="onStateChange($event)">
                    <option value="">Select State</option>
                    <option *ngFor="let s of allStates" [value]="s"> {{ s }} </option>
                  </select>
                  <label>State <span class="text-danger">*</span></label>
                </div>
                <small class="text-danger" *ngIf="addressSubmitted && f.state.invalid"> State required </small>
              </div>

              <!-- PINCODE -->
              <div class="col-md-6">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="pinCode" placeholder="Pincode" maxlength="6">
                  <label>PinCode <span class="text-danger">*</span></label>
                </div>
                <small class="text-danger" *ngIf="addressSubmitted && f.pinCode.invalid"> Enter valid 6 digit pincode
                </small>
              </div>

              <!-- SAVE -->
              <button type="button" class="btn btn-success px-4" (click)="saveAddress()"> {{ isEditMode ? 'Update
                Address'
                : 'Save Address' }} </button>
            </form>

          </div>
        </div>

        <!-- ================= PAYMENT MODE ================= -->
        <div class="card mt-3">
          <div class="card-header fw-bold">Payment Method</div>

          <div class="card-body">
            <div class="form-check">
              <input type="radio" name="paymentMode" value="PREPAID" [(ngModel)]="paymentMode"
                (change)="onPaymentModeChange('PREPAID')">
              <label class="ms-1">Online Payment</label>
            </div>

            <div class="form-check" *ngIf="isCodAvailable">
              <input type="radio" name="paymentMode" value="COD" [(ngModel)]="paymentMode"
                (change)="onPaymentModeChange('COD')">
              <label class="ms-1">Cash On Delivery</label>
            </div>

          </div>
        </div>

        <!-- ================= SHIPPING PARTNER ================= -->
        <div class="card mt-3 shadow-sm" *ngIf="paymentMode === 'PREPAID' && shippingDetails?.length">
          <div class="card-header fw-bold">
            Shipping Method
          </div>
          <div class="card-body">
            <div *ngFor="let ship of shippingDetails" class="mb-3">
              <label
                class="w-100 border rounded p-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2">
                <!-- Left Section -->
                <div class="d-flex align-items-start gap-2 w-100">
                  <input type="radio" name="shipping" class="mt-1"
                    [checked]="selectedShipping?.shippingPartner === ship.shippingPartner"
                    (change)="selectedShipping = ship; shipping = ship.amount; updatePaymentBreakup()" />
                  <div>
                    <strong>{{ ship.shippingPartner }}</strong>
                    <div class="text-muted small">
                      Shipping calculated based on cart quantity
                    </div>
                  </div>
                </div>
                <!-- Right Section (Price) -->
                <div class="text-md-end w-100 w-md-auto">
                  <span *ngIf="ship.amount == 0" class="text-success fw-semibold">
                    FREE
                  </span>
                  <span *ngIf="ship.amount > 0" class="fw-semibold">
                    ₹ {{ ship.amount }}
                  </span>
                </div>
              </label>
            </div>
          </div>
        </div>

        <!-- ================= SUMMARY ================= -->
        <div class="card border-0 shadow rounded-4">
          <div class="card-header bg-white fw-bold">Order Summary</div>

          <div class="card-body">

            <!-- Product Total -->
            <div class="d-flex justify-content-between mb-2">
              <span>Product Total</span>
              <span>₹{{ formatIndianCurrency(productTotal) }}</span>
            </div>

            <!-- Discount (Show Only If Exists) -->
            <div *ngIf="discountTotal > 0" class="d-flex justify-content-between mb-2 text-danger">
              <span>Discount</span>
              <span>- ₹{{ formatIndianCurrency(discountTotal) }}</span>
            </div>

            <!-- Shipping (Hide if Free) -->
            <div *ngIf="shipping > 0 && paymentMode !== 'COD'" class="d-flex justify-content-between mb-2">
              <span>Shipping</span>
              <span>₹{{ formatIndianCurrency(shipping) }}</span>
            </div>

            <!-- Free Shipping Label -->
            <div *ngIf="selectedShipping && shipping === 0 && paymentMode !== 'COD'"
              class="d-flex justify-content-between mb-2 text-danger">
              <span>Shipping</span>
              <span>FREE</span>
            </div>

            <!-- <hr> -->

            <!-- Final Order Value -->
            <!-- <div class="d-flex justify-content-between mb-2 fw-bold">
            <span>Order Value</span>
            <span>₹{{ formatIndianCurrency(orderValue) }}</span>
          </div> -->

            <!-- COD Charge -->
            <div *ngIf="paymentMode === 'COD' && codAmount > 0"
              class="d-flex justify-content-between mb-2 text-primary">
              <span>COD Handling Fee (Pay Now)</span>
              <span>₹{{ formatIndianCurrency(codAmount) }}</span>
            </div>

            <hr>

            <!-- Pay Now -->
            <div class="d-flex justify-content-between mb-2 fw-bold text-success">
              <span>Pay Now <span class="text-danger text-xs">(Inclusive of Tax)</span></span>
              <span>₹{{ formatIndianCurrency(payNowAmount) }}</span>
            </div>

            <!-- Pay Later (Only for COD) -->
            <div *ngIf="paymentMode === 'COD'" class="d-flex justify-content-between mb-2 text-danger">
              <span>Pay On Delivery</span>
              <span>₹{{formatIndianCurrency( payLaterAmount) }}</span>
            </div>

            <!-- Button -->

            <button type="button" class="btn btn-primary w-100 mt-3 py-2"
              [disabled]="isPlaceOrderDisabled() || isProcessingPayment" (click)="placeOrder()">

              {{
              isProcessingPayment
              ? 'Processing Payment...'
              : 'Pay ₹ ' + formatIndianCurrency(payNowAmount)
              }}

            </button>


            <small class="text-danger text-center mt-2 d-block" *ngIf="getDisableReason()">
              {{ getDisableReason() }}
            </small>
          </div>
        </div>
      </div>

    </div>
  </div>


</div>

<app-web-footer></app-web-footer>